// extracted by mini-css-extract-plugin
export var errorBanner = "_ix-2";
export var scroller = "_ix-0";
export var thinking = "_ix-1";
export var visuallyHidden = "_ix-3";